import Footer from "../components/Footer";
import Hero from "../components/Hero";

const Home = () => {
  return (
    <>
      <Hero />
      <Footer />
    </>
  );
};

export default Home;
